/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Table, theme } from "@nordcloud/gnui";

export const SwitchWrap = styled.div`
  display: inline-block;
`;

export const StyledTd = styled(Table.td)`
  text-align: right;
  vertical-align: middle;
  position: relative;
`;

export const StyledTr = styled(Table.tr)<{ show?: boolean }>`
  display: ${({ show }) => (show ? "table-row" : "none")};
  background: ${theme.color.background.ui03};

  &:last-child > td {
    padding-bottom: 1.25rem;
  }
`;

export const TdWithMinWidth = styled(Table.td)`
  min-width: 1rem;
  max-width: 1rem;
  width: 1rem;
  cursor: pointer;
  vertical-align: middle;
`;
